import { toTitleCase } from "utils/formatText";
import { AMC_AUDIENCE_STATUSES, CANNED_QUERIES, FEATURED_REPORTS } from "../utils";

export const buildAudienceTemplateFilter = (templates = []) => {
  return {
    label: "Audience Type",
    id: "template_display_name",
    format: "select",
    selectOptions: [
      {
        label: "All Types",
        value: "all",
        clearable: false,
      },
      ...templates.map((audienceTemplate) => ({
        label: audienceTemplate.audience_display_name,
        value: audienceTemplate.audience_template_name,
      })),
    ],
    override: true,
    defaultValue: "all",
    operator: "=",
    filterFunction: (audience, filterValue) => {
      if (filterValue !== "all") {
        return audience.sql_template[0]?.template_name === filterValue;
      }
      return true;
    },
  };
};

export const buildAudienceTagsFilter = (templates = []) => {
  const allTemplateTags = [
    ...new Set(templates?.flatMap((t) => t.recommended_tags)?.map((t) => t.replace(/[^a-zA-Z0-9 ]/g, ""))),
  ];

  return {
    label: "Tags",
    id: "audience_template_tags",
    format: "multi-select",
    selectOptions: [
      {
        label: "All Types",
        value: "all",
        clearable: false,
      },
      ...allTemplateTags.map((tag) => ({
        label: tag?.toLowerCase() === "fsi" ? "FSI" : toTitleCase(tag.replace(/[^a-zA-Z0-9 ]/g, "")),
        value: tag,
      })),
    ],
    override: true,
    defaultValue: "all",
    operator: "=",
    filterFunction: (audience, filterValue) => {
      if (filterValue !== "all") {
        return audience.recommended_tags?.join("")?.includes(filterValue);
      }
      return true;
    },
  };
};

export const AUDIENCE_STATUS_FILTER = {
  label: "Status",
  id: "status",
  format: "select",
  selectOptions: [
    {
      label: "All Statuses",
      value: "all",
      clearable: false,
    },
    ...AMC_AUDIENCE_STATUSES,
  ],
  override: true,
  defaultValue: "all",
  operator: "=",
  filterFunction: (audience, filterValue) => {
    if (filterValue !== "all") {
      return audience.status === filterValue;
    }
    return true;
  },
};

export const buildAudienceAsinsFilter = (asins) => {
  const asinOptions = [...new Set(asins)]?.map((asin) => ({
    value: asin,
    label: asin,
  }));

  return {
    label: "ASINs",
    id: "audience_asins",
    format: "select",
    selectOptions: [
      {
        value: "all",
        label: "All ASINs",
      },
      ...asinOptions.flat(),
    ],
    override: true,
    defaultValue: "all",
    operator: "custom",
    filterFunction: (audience, filterValue) => {
      if (filterValue === "all") {
        return true;
      }

      const { sql_template } = audience;
      const audienceAsins = sql_template[0]?.asins ?? [];

      return audienceAsins.includes(filterValue);
    },
  };
};

export const AMC_REPORT_TYPE_FILTER = {
  label: "Report Type",
  id: "name",
  format: "select",
  selectOptions: [
    {
      label: "All Report Types",
      value: "all",
      clearable: false,
    },
    ...[...CANNED_QUERIES, ...FEATURED_REPORTS].map((type) => {
      return { label: type.display_name, value: type.name };
    }),
  ],
  override: true,
  defaultValue: "all",
  operator: "=",
  filterFunction: (subscription, filterValue) => {
    if (filterValue !== "all") {
      return subscription.name === filterValue;
    }
    return true;
  },
};
